import { useCallback, useEffect, useState } from 'react';
import UniversalAssociationsSelectSearchResults from './UniversalAssociationsSelectSearchResults';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message

// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'atom... Remove this comment to see the full error message
import { deref, watch, unwatch } from 'atom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isError, isLoading, isResolved } from 'reference-resolvers/utils';
import get from 'transmute/get';
import { OrderedMap, Map as ImmutableMap } from 'immutable';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../r... Remove this comment to see the full error message
import UniversalAssociationOptionRecord from '../records/UniversalAssociationOptionRecord';
import { ObjectTypesToIds } from 'customer-data-objects/constants/ObjectTypeIds';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import I18n from 'I18n';
import { is } from 'immutable';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../h... Remove this comment to see the full error message
import { universalAssociationOptionComparator } from '../helpers/parseUniversalEngagementAssociations';
import { jsx as _jsx } from "react/jsx-runtime";
const optionsReducer = ({
  updatedOptionRecord,
  option,
  optionId,
  associationRecord,
  defaultValue,
  notMatchingValue
}) => {
  const updatedRecordMatchingOption = associationRecord.getIn(['associationOptionRecords', `${optionId}`], defaultValue);
  if (!is(option, updatedRecordMatchingOption)) {
    return notMatchingValue || updatedRecordMatchingOption;
  }
  return updatedOptionRecord;
};
const SearchResultsReferenceResolverWrapper = ({
  canEdit,
  emailRecipientsIds,
  engagementOrInteractionType,
  isSearching,
  onToggleSelectAssociation,
  readOnly,
  resolver,
  searchText,
  selectedAssociationRecord,
  selectedObjectTypeId,
  shouldDisableLastAssociation,
  singularObjectName
}) => {
  const [searchAtoms, setSearchAtoms] = useState(ImmutableMap());
  const [searchResults, setSearchResults] = useState(OrderedMap({
    [selectedObjectTypeId]: selectedAssociationRecord
  }));
  const [currentSearchId, setCurrentSearchId] = useState(1);
  const [previousSearchText, setPreviousSearchText] = useState('');
  const [previousSelectedAssociationRecord, setPreviousSelectedAssociationRecord] = useState(selectedAssociationRecord);
  const getToggledOptionRecord = useCallback(() => {
    const removedRecord = previousSelectedAssociationRecord.get('associationOptionRecords').reduce((removedOptionRecord, option, optionId) => optionsReducer({
      associationRecord: selectedAssociationRecord,
      defaultValue: UniversalAssociationOptionRecord({
        objectId: +optionId
      }),
      option,
      optionId,
      updatedOptionRecord: removedOptionRecord
    }), undefined);
    const addedRecord = selectedAssociationRecord.get('associationOptionRecords').reduce((addedOptionRecord, option, optionId) => optionsReducer({
      associationRecord: previousSelectedAssociationRecord,
      notMatchingValue: option,
      option,
      optionId,
      updatedOptionRecord: addedOptionRecord
    }), undefined);
    return removedRecord || addedRecord;
  }, [previousSelectedAssociationRecord, selectedAssociationRecord]);

  // Handles updating search results in place when adding or removing an association
  useEffect(() => {
    const hasSelectedRecordOptionsChanged = !is(previousSelectedAssociationRecord.get('associationOptionRecords'), selectedAssociationRecord.get('associationOptionRecords'));
    const shouldUpdateSearchResults = isSearching && selectedObjectTypeId === previousSelectedAssociationRecord.get('toObjectTypeId') && hasSelectedRecordOptionsChanged;
    if (shouldUpdateSearchResults) {
      const toggledOptionRecord = getToggledOptionRecord();
      const updatedSearchResults = searchResults.updateIn([selectedObjectTypeId, 'associationOptionRecords', `${toggledOptionRecord.get('objectId')}`], option => option && option.set('isSelected', toggledOptionRecord.get('isSelected')));
      setPreviousSelectedAssociationRecord(selectedAssociationRecord);
      setSearchResults(updatedSearchResults);
    }
  }, [getToggledOptionRecord, isSearching, previousSelectedAssociationRecord, searchResults, selectedAssociationRecord, selectedObjectTypeId]);
  const cleanupAllWatchedAtoms = useCallback(() => {
    searchAtoms.forEach(unwatcher => unwatcher());
  }, [searchAtoms]);
  const watchSearchAtom = useCallback((searchId, searchAtom, searchHandler) => {
    setSearchAtoms(searchAtoms.set(searchId, () => unwatch(searchAtom, searchHandler)));
    watch(searchAtom, searchHandler);
  }, [searchAtoms]);
  const getFormattedDescription = useCallback(description => {
    if (!description) {
      return undefined;
    }
    return selectedObjectTypeId === ObjectTypesToIds.CONTACT ? I18n.text('universalAssociationsSelect.optionFormatting.emailWrapper', {
      secondaryDisplayLabel: description
    }) : I18n.text('universalAssociationsSelect.optionFormatting.parentheses', {
      secondaryDisplayLabel: description
    });
  }, [selectedObjectTypeId]);
  const formatResponse = useCallback(response => {
    const results = get('results', response);
    if (!results.size) {
      return OrderedMap();
    }
    const optionRecords = results.reduce((acc, option) => {
      const objectId = +option.get('id');
      const isSelected = Boolean(selectedAssociationRecord.get('associationOptionRecords').find(optionRecord => optionRecord.get('objectId') === objectId && optionRecord.get('isSelected')));
      const description = option.get('description');
      // SecondaryDisplayLabels on a contact are to be wrapped in <> not () as they are emails

      const formattedSecondaryDisplayLabel = getFormattedDescription(description);
      return acc.set(option.get('id'), UniversalAssociationOptionRecord({
        isSelected: !!isSelected,
        objectId,
        primaryDisplayLabel: option.get('label'),
        secondaryDisplayLabel: formattedSecondaryDisplayLabel
      }));
    }, ImmutableMap());
    const sortedOptionsMap = optionRecords.sort((optionA, optionB) => universalAssociationOptionComparator(optionA, optionB, false));
    const resultRecord = selectedAssociationRecord.set('hasMore', get('hasMore', response)).set('offset', get('offset', response)).set('associationOptionRecords', sortedOptionsMap);
    return OrderedMap({
      [selectedObjectTypeId]: resultRecord
    });
  }, [getFormattedDescription, selectedAssociationRecord, selectedObjectTypeId]);
  const handleSearch = useCallback(response => {
    if (isError(response)) {
      throw response;
    }
    if (!isResolved(response)) {
      return;
    }
    const resultRecord = formatResponse(response);
    const resultRecordOptions = resultRecord.getIn([selectedObjectTypeId, 'associationOptionRecords']);
    const dedupedSelectedAssociationRecordOptions = selectedAssociationRecord.get('associationOptionRecords').toList().filter(option => {
      return !resultRecordOptions ? option.get('isSelected') : option.get('isSelected') && !resultRecord.getIn([selectedObjectTypeId, 'associationOptionRecords']).some(resultRecordOption => resultRecordOption.get('objectId') === option.get('objectId'));
    });
    let resultRecordWithSelectedOptions = resultRecord;
    if (!resultRecordWithSelectedOptions.size) {
      resultRecordWithSelectedOptions = resultRecord.set(selectedObjectTypeId, selectedAssociationRecord);
    }
    dedupedSelectedAssociationRecordOptions.forEach(option => {
      resultRecordWithSelectedOptions = resultRecordWithSelectedOptions.setIn([selectedObjectTypeId, 'associationOptionRecords', `${option.get('objectId')}`], option);
    });

    // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'OrderedMap<unknown, unknown>' is... Remove this comment to see the full error message
    setSearchResults(resultRecordWithSelectedOptions);
  }, [formatResponse, selectedAssociationRecord, selectedObjectTypeId]);

  // Handles searching
  useEffect(() => {
    if (!isSearching) {
      setSearchResults(OrderedMap({
        [selectedObjectTypeId]: selectedAssociationRecord
      }));
      setPreviousSearchText('');
    } else if (searchText !== previousSearchText || selectedObjectTypeId !== previousSelectedAssociationRecord.get('toObjectTypeId')) {
      const searchAtom = resolver.search({
        count: 20,
        offset: 0,
        query: searchText
      });
      const currentResult = deref(searchAtom);
      // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'string | undefined' is not assig... Remove this comment to see the full error message
      setPreviousSearchText(searchText);
      setPreviousSelectedAssociationRecord(selectedAssociationRecord);
      if (isResolved(currentResult)) {
        handleSearch(currentResult);
      } else {
        setSearchResults(currentResult);
        watchSearchAtom(currentSearchId, searchAtom, handleSearch);
        setCurrentSearchId(currentSearchId + 1);
      }
    }
    return cleanupAllWatchedAtoms;
  }, [cleanupAllWatchedAtoms, currentSearchId, handleSearch, isSearching, previousSearchText, previousSelectedAssociationRecord, resolver, searchText, selectedAssociationRecord, selectedObjectTypeId, watchSearchAtom]);
  if (isLoading(searchResults)) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      grow: true,
      className: "m-top-4",
      "data-selenium-test": "uas-search-results-loading-spinner"
    });
  }
  return /*#__PURE__*/_jsx(UniversalAssociationsSelectSearchResults, {
    canEdit: canEdit,
    emailRecipientsIds: emailRecipientsIds,
    engagementOrInteractionType: engagementOrInteractionType,
    isSearching: isSearching,
    onToggleSelectAssociation: onToggleSelectAssociation,
    readOnly: readOnly,
    searchResults: searchResults,
    searchText: searchText || '',
    selectedObjectTypeId: selectedObjectTypeId,
    shouldDisableLastAssociation: shouldDisableLastAssociation,
    singularObjectName: singularObjectName
  });
};
export default SearchResultsReferenceResolverWrapper;